// extracted by mini-css-extract-plugin
export default {"slider":"field-slider_slider__QIuNJ","grid":"field-slider_grid__JkpUL","rotate":"field-slider_rotate__v+26R"};